<template src="./main.html"></template>

<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import ToolBar from "@/components/layout/ToolBar";
import LeftBar from "@/components/layout/LeftBar";
import PaginaDemo from "./PaginaDemo.vue";

export default {
  name: "MainPage",
  components: {
    ToolBar,
    LeftBar,
    PaginaDemo
  },
  setup() {
    const store = useStore();

    // Reactive state
    const menu = ref([]);
    const disabilitaBtn = ref(false);
    const drawer = ref(true);

    // Computed properties
    const loading = computed(() => store.state.app.loading);
    const utente = computed(() => store.getters["user/getNome"]);
    const mail = computed(() => store.getters["user/getMail"]);

    const licenzaStato = computed(() => store.getters['user/getLicenzaStato'])
    //const emailConfirmata = computed(() => store.getters['user/getEmailConfirmata'])
    const isDemo = computed(() => licenzaStato.value !== 1)


    // Methods
    const init = async () => {
      try {
        // User info
        const res = await store.dispatch("user/userInfo");
        menu.value = res.data.menu;
      } catch (error) {
        console.log(error);
      }
    };

    const esci = async () => {
      disabilitaBtn.value = true;
      try {
        await store.dispatch("auth/logout");
      } catch (error) {
        console.log(error);
      }
    };
    const role = computed(() => store.getters['user/getRole'])

    const aggiornaRichieste = () => {
      if (role.value >= 2) {  // solo admin/superadmin
        store.dispatch('app/aggiornaRichiestePendenti')
      }
    };

    onMounted(() => {
      init();
      aggiornaRichieste();
      setInterval(aggiornaRichieste, 5 * 60 * 1000);

    });

    return {
      menu,
      disabilitaBtn,
      loading,
      utente,
      mail,
      drawer,
      init,
      esci,
      isDemo
    };
  },
};
</script>